import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";

export default class extends Controller {
  static values = {
    content: String,
    allowHtml: { type: Boolean, default: true },
    placement: { type: String, default: "top" },
    theme: String,
  };

  connect() {
    if (!this.contentValue) return;

    this.tooltip = tippy(this.element, {
      content: this.contentValue,
      theme: this.themeValue,
      allowHTML: this.allowHtmlValue,
      interactive: true,
      appendTo: () => document.body,
      placement: this.placementValue,
      delay: [150, null],
    });
  }

  disconnect() {
    this.tooltip?.destroy();
  }
}
